import { createResourceStore } from './createResourceStore';
import { FILTER_CACHE_TTL } from '../shared/config/constants';

const useToolStore = createResourceStore({
  endpoint: '/admin/tools',
  collectionKey: 'tools',
  itemKey: 'tool',
  extraState: { tool: null },
  cache: { ttl: FILTER_CACHE_TTL.tools },
  methods: {
    fetch: 'fetchTools',
    create: 'createTool',
    update: 'updateTool',
    delete: 'deleteTool',
  },
});

export default useToolStore;
